<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateEmployeeDepartment"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md md:h-auto h-screen overflow-y-auto shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Create Employee Department</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="() => closeCreateDepartment()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1 capitalize">Company</label>
              <select
                name=""
                id=""
                v-model="info.LocationId"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
                @change="() => setBranches()"
              >
                <option
                  v-for="location in saved_locations"
                  :key="location.Name"
                >
                  {{ location.Name }}
                </option>
              </select>
            </div>
            <div class="text-sm">
              <label class="block pb-1 capitalize">Branch</label>
              <select
                name=""
                id=""
                v-model="info.BranchId"
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
                @change="() => setDepartments()"
              >
                <option
                  v-for="branch in branchesToSelect"
                  :key="branch.Id"
                  :value="branch.Id"
                >
                  {{ branch.Name }}
                </option>
              </select>
            </div>

            <div class="text-sm">
              <!-- {{ saved_departments }} -->
              <label class="block pb-1 capitalize">Department</label>
              <select
                name=""
                id=""
                v-model="info.DepartmentId"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
                @change="() => setJobTitles()"
                @click="() => setDepartments()"
              >
                <option
                  v-for="department in departmentsToSelect /*departmentsToSelect*/"
                  :key="department.DepartmentId"
                >
                  {{ department.Name }}
                </option>
              </select>
            </div>
            <div class="text-sm">
              <label class="block pb-1 capitalize">JobTitle</label>
              <select
                name=""
                id=""
                v-model="info.JobTitleId"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
                :disabled="!info.DepartmentId.length"
              >
                <option
                  v-for="jobTitle in saved_jobTitles"
                  :key="jobTitle.Name"
                >
                  {{ jobTitle.Name }}
                </option>
              </select>
            </div>
            <!-- multi-selct-drop-down -->
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>
<!--  :disabled="!info.LocationId.length" -->
<!--    :disabled="!info.BranchId.length" -->
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import Loader from '@/components/loader/loader.vue';
export default {
  name: 'CreateEmployeeDepartments',
  props: ['showCreateEmployeeDepartment', 'reload', 'closeCreateDepartment'],
  components: { Loader },
  data() {
    return {
      create_error: null,
      create_success: null,
      loading: false,
      saved_locations: [],
      saved_branches: [],
      saved_departments: [],
      saved_jobTitles: [],
      branchesToSelect: [],
      departmentsToSelect: [],
      jobTitlesToSelect: [],
      info: {
        EmployeeId: '',
        LocationId: '',
        BranchId: '',
        DepartmentId: '',
        JobTitleId: '',
      },
    };
  },
  computed: {
    ...mapGetters(['getOrganization', 'getToken', 'getCurrentEmployeeId']),
  },
  created() {
    this.getSavedData();
  },
  watch: {
    showCreateEmployeeDepartment(old, newState) {
      if (!newState) {
        this.info = {
          EmployeeId: '',
          LocationId: '',
          BranchId: '',
          DepartmentId: '',
          JobTitleId: '',
        };
      }
    },
  },
  methods: {
    setBranches() {
      this.branchesToSelect = this.saved_branches.filter(
        (branch) => branch.Location === this.info.LocationId
      );
      this.setDepartments();
    },

    setDepartments() {
      if (this.info.BranchId) {
        // console.log(this.info.BranchId);
        this.departmentsToSelect = this.saved_departments.filter(
          (department) => department.BranchId === this.info.BranchId
        );
        console.log(this.departmentsToSelect);
      } else {
        this.departmentsToSelect = this.saved_departments.filter(
          (department) =>
            department.LocationName.trim().toLowerCase() ===
              this.info.LocationId.trim().toLowerCase() &&
            department.BranchId == ''
        );

        // console.log(this.saved_departments, this.info.LocationId);
      }
    },
    setJobTitles() {
      // //console.log(this.saved_jobTitles)
      // this.jobTitlesToSelect = this.saved_jobTitles.filter(job => job.Name === this.info.)
    },

    // /{organization}/employee/department/v1/create
    create() {
      this.loading = true;

      this.info.EmployeeId = this.getCurrentEmployeeId;
      this.info.LocationId = this.saved_locations.find(
        (location) => location.Name.trim() === this.info.LocationId
      ).Id;
      if (this.info.BranchId) {
        this.info.BranchId = this.saved_branches.find(
          (branch) => branch.Id === this.info.BranchId
        ).Id;
      } else {
        this.info.BranchId = '';
        delete this.info.BranchId;
      }
      this.info.DepartmentId = this.saved_departments.find(
        (department) => department.Name.trim() === this.info.DepartmentId
      ).DepartmentId;
      this.info.JobTitleId = this.saved_jobTitles.find(
        (job) => job.Name.trim() === this.info.JobTitleId
      ).Id;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };
      axios
        .post(
          `${this.getOrganization}/employee/department/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit('closeOnSuccess');
              this.create_success = response.data.StatusMessage;
              (this.info = {
                EmployeeId: '',
                LocationId: '',
                BranchId: '',
                DepartmentId: '',
                JobTitleId: '',
              }),
                setTimeout(() => {
                  this.create_success = null;
                  this.reload();
                }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    getSavedData() {
      this.loading = true;
      let endpoints = [
        `${this.getOrganization}/setup/location/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/branch/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/request`,
      ];
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      Promise.all(endpoints.map((endpoint) => axios.get(endpoint, options)))
        .then(
          axios.spread((...response) => {
            this.loading = false;
            this.saved_locations = response[0].data.Data;
            this.saved_branches = response[1].data.Data;
            this.saved_departments = response[2].data.Data;
            this.saved_jobTitles = response[3].data.Data;
          })
        )
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
